/**
* Include your custom JavaScript here.
*
* We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
* changes on product page, you can attach a listener to the document:
*
* document.addEventListener('variant:changed', function(event) {
    *   var variant = event.detail.variant; // Gives you access to the whole variant details
    * });
    *
    * You can also add a listener whenever a product is added to the cart:
    *
    * document.addEventListener('product:added', function(event) {
    *   var variant = event.detail.variant; // Get the variant that was added
    *   var quantity = event.detail.quantity; // Get the quantity that was added
    * });
    *
    * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
    * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
    * that was added so the theme can properly update the quantity:
    *
    * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
    *   bubbles: true,
    *   detail: {
    *     quantity: 1
    *   }
    * }));
    *
    * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
    * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
    *
    * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    *   bubbles: true
    * }));
    */
    
    // add class to product card if out of stock
    
    var getProductCards = setInterval(function () {
        if (jQuery('#fast-simon-serp-app')[0]) {
            var productGrid = jQuery('#fast-simon-serp-app')[0].shadowRoot.querySelector('#fs-serp-page');
            if (productGrid) {
                var productCards = productGrid.querySelectorAll('.product-card');
                productCards.forEach(function(k,v){
                    var element = jQuery(k);
                    if ( element.find('.out-of-stock-wrapper').length > 0 ) {
                        // EDITS HERE: 
                        element.find('.fs-product-main-image-wrapper').css('opacity', '0.4'); 
                    }
                })
            }
        }
        else {
        }
    }, 150);
    
    // add free barbie product to cart 
    
    $(document).ready(function(){
        if (document.cookie.includes('discount_code=BARBIE23')) {
            var productArray = [];
            var promoCollection = 'life-in-plastic';
            var totalPromoPrice = 0;
            var promoConditionPrice = 4500;
            var freeProductHandle = 'barbie-kids-unicorn-accessory-set';
            var freeProductId = 43894108225761;
            var hasFreeProduct = false;
            
            $.ajax({
                type: 'GET',
                url: '/cart.json',
                dataType: 'json',
                success: function(data) { 
                    data.items.forEach(function(v,k){
                        productArray.push(v);
                    })
                }
            }).done(function(){
                $.ajax({
                    type: 'GET',
                    url: '/collections/' + promoCollection + '/products.json?limit=250',
                    dataType: 'json',
                    success: function(data) {
                        data.products.forEach(function(v,k){
                            productArray.forEach(function(v2,k2){
                                if (v.handle == v2.handle) { 
                                    totalPromoPrice += v2.final_line_price;
                                    if (v2.handle == freeProductHandle) {
                                        hasFreeProduct = true;
                                    }
                                }
                            })
                        });
                
                        if (totalPromoPrice >= promoConditionPrice && !hasFreeProduct) {
                            $.ajax({
                                type: 'POST',
                                url: '/cart/add.js',
                                data: {
                                    quantity: 1,
                                    id: freeProductId
                                },
                                dataType: 'json',
                                error: function(data) {
                                    console.log('error', data);
                                }
                            }).done(function(){
                                // refresh cart
                                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                                
                            })
                        }
                    }
                });
            });
        }
    });